import React, { lazy, Suspense, useState, useEffect } from 'react'
import { Flex, Box } from '@chakra-ui/react'
import { Loading } from '../helpers/Loading'
import { getTopList, getTopArtist } from '../../utils/api'
import { useTranslation } from 'react-i18next'
import { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { SectionHeader } from '../helpers/SectionHeader'
import { formatDate, httpToHttps } from '../../utils/helper-functions'
import { ChevronDownIcon } from '@chakra-ui/icons'

// eslint-disable-next-line
const TopSongsUS = lazy( () => import( /* webpackPrefetch: true */ '../Discover/TopSongsUS' ) )
const TopSongsUK = lazy( () => import( /* webpackPrefetch: true */ '../Discover/TopSongsUK' ) )
const PopularPlaylists = lazy( () => import( /* webpackPrefetch: true */ './NetizensPlaylists' ) )

export const OfficialChartsList = () => {
  const history = useHistory()
  const [loading, setLoading] = useState( false )
  const [topLists, setTopLists] = useState( [] )
  const [allLists, setAllLists] = useState( [] )
  const [showAll, setShowAll] = useState( false )
  const { i18n, ready } = useTranslation( ['chartlist', 'topCharts'], { useSuspense: false } )
  // console.log( i18n?.options?.resources?.topCharts["en-US"], "i18n" )
  const topChartsID = [11641012, 180106, 3812895, 180106, 2023401535]
  // let id
  const selectedList = []
  const allChartsList = []
  const toplistRef = useRef( null )
  const alllistRef = useRef( null )
  // top charts
  useEffect( () => {
    const getTopLists = async () => {
      setLoading( true )
      const lists = await getTopList()
      // eslint-disable-next-line
      lists.list.map( ( list, i ) => {
        const ID = topChartsID.find( id => id )
        if ( list.tags.includes( "欧美" || "电子" ) || list.id === ID ) {
          let filtered = list
          selectedList.push( filtered )
          let index = selectedList.indexOf( filtered )
          filtered.englishTitle = i18n?.options?.resources?.chartlist["en-US"][index]?.name
          setTopLists( selectedList )
          // return selectedList
        }
        let newItem = list
        allChartsList.push( newItem )
        let index = allChartsList.indexOf( newItem )
        newItem.englishTitle = i18n?.options?.resources?.topCharts["en-US"][index]?.name
        setAllLists( allChartsList )
      } )
      setLoading( false )
    }
    getTopLists()
  }, [] )

  function handleClick( lang ) {
    i18n.changeLanguage( lang ).then( () => {
      // console.log( i18n.language )
      // history.push( `/${i18n.language}${t( "/name" )}` )
    } )
  }
  return (
    <Suspense fallback={loading && <Loading />}>
      <Flex
        flexDir="column"
        mt={4}
        pt={[3, 1, 1, 2]}
        // px={[1, 2, 2, 4]}
        // maxW="container.xl"
        w="100%"
      >
        {/* {loading && <Loading />} */}
        <article>
          <div className="playlists__wrapper">
            <SectionHeader
              title="OFFICIAL TOP CHARTS"
            // icontype="iconBtn" iconOne={<ChevronDownIcon />}
            // iconTwo={null} setShowMore={setShowAll}
            />
            <div className="playlists__inner">
              {showAll ? allLists?.map( ( list, i ) => {
                list.englishTitle = i18n?.options?.resources?.topCharts["en-US"][i]?.name
                return (
                  <Box className="playlists__body"
                    key={list.id} ref={alllistRef}
                    onClick={() => {
                      handleClick( 'en-US' )
                      history.push( { pathname: `/playlist/${list.id}`, index: i } )
                    }}>
                    <img src={httpToHttps( list?.coverImgUrl + "?param=200y200" )} alt={list?.englishTitle}
                    />
                    <p>{list?.englishTitle}</p>
                    {" "}
                    <span>
                      Updated {": "}
                      <b>
                        {` [${formatDate( list?.trackUpdateTime ).slice( 0, 10 )}]`}
                      </b>
                    </span>
                  </Box>
                )
              } )
                : topLists?.map( ( top, i ) => {
                  return (
                    <Box className="playlists__body"
                      key={top.id} ref={toplistRef}
                      onClick={() => {
                        handleClick( 'en-US' )
                        history.push( { pathname: `/playlist/${top.id}`, i: i } )
                      }}>
                      <img src={top?.coverImgUrl + "?param=300y300"} alt={top?.englishTitle}
                      />
                      <p>{top?.englishTitle}</p>
                      {" "}
                      <span>
                        Updated {": "}
                        <b>
                          {` [${formatDate( top?.trackUpdateTime ).slice( 0, 10 )}]`}
                        </b>
                      </span>
                    </Box>
                  )
                } )
              }
            </div>
          </div>
        </article>
      </Flex>
      <PopularPlaylists />
    </Suspense>
  )
}
/**            <TopSongsUK />
                <TopSongsUS />
                            <article>
                    <div className="playlists__wrapper">
                        {console.log( allLists, "all" )}
                        <div className="playlists__inner">
                            {showAll ?
                                : null
                            }
                        </div>
                    </div>
                </article>
*/